import { useRef, useState } from "react";
import { Chart } from "react-chartjs-2";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

const BookingCountBar = ({ filter, data }) => {
    const [showData, setShowData] = useState(false);

    const labels = data?.bookingCounts?.map((val) => Object.keys(val)[0]) ?? [];
    const bookingData = data?.bookingCounts?.map((val) => Object.values(val)[0]) ?? [];
    const daysData = data?.dayCounts?.map((val) => Object.values(val)[0]) ?? [];

    const totalBookings = data?.bookingCounts?.reduce((sum, b) => sum + Number(Object.values(b)[0] || 0), 0) ?? 0;
    const totalDays = data?.dayCounts?.reduce((sum, b) => sum + Number(Object.values(b)[0] || 0), 0) ?? 0;

    const barData = {
        labels,
        datasets: [
            {
                type: "line",
                label: "Days",
                data: daysData,
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgb(255, 99, 132)",
                borderWidth: 3,
                pointRadius: 5,
                pointHoverRadius: 7,
                tension: 0,
                fill: false,
                yAxisID: "y1",
                order: 1,
                datalabels: {
                    display: showData,
                    align: "top",
                    anchor: "end",
                    color: "red",
                    font: { weight: "normal" },
                    formatter: (value) => `${value} days`,
                },
            },
            {
                type: "bar",
                label: "Bookings",
                data: bookingData,
                backgroundColor: "rgba(54, 162, 235, 0.7)",
                borderRadius: 6,
                borderSkipped: false,
                yAxisID: "y",
                order: 2,
                datalabels: {
                    display: showData,
                    anchor: "end",
                    align: "top",
                    color: "#000",
                    font: { weight: "normal" },
                    formatter: (value) => value,
                },
            },
        ],
    };
    const maxValue = Math.max(...bookingData);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: "index",
            intersect: false,
        },
        plugins: {
            legend: { position: "top" },
            datalabels: { clip: false },
        },
        scales: {
            x: {
                stacked: false,
                grid: { display: false },
                
            },
            y: {
                beginAtZero: true,
                position: "left",
                title: { display: true, text: "Booking Count" },
                max: maxValue + (maxValue * 0.2),
            },
            y1: {
                beginAtZero: true,
                position: "right",
                title: { display: true, text: "Days Count" },
                grid: { drawOnChartArea: false },
            },
        },
    };

    return (
        <div className="booking-count-bar">
            <div className="d-flex justify-content-between">
                <h3>Booking Count</h3>
                <div className="d-flex align-items-center gap-2">
                    <span>{totalBookings} Bookings — {totalDays} Days</span>
                    <button className="btn" onClick={() => setShowData(!showData)} >
                        {
                            showData ?
                                <FaRegEye />
                                :
                                <FaRegEyeSlash />
                        }
                    </button>
                </div>
            </div>

            <div className="booking-count-bar-scroll">
                <div className="booking-count-bar-container" style={{ width: `${Math.max(labels.length * 90, 1000)}px`, height: "400px" }} >
                    <Chart
                        type="bar"
                        data={barData}
                        options={options}
                    />
                </div>
            </div>
        </div>
    );
};

export default BookingCountBar;